import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'clsx';
import { InlineMessage, InlineMessageTypePropType } from '../inline-message';
import { RequiredIndicator } from '../required-indicator';
import { ButtonThemeService } from '../../services/button-theme-service';
import style from './dropdown-menu-title-with-label.module.less';

export const DropdownMenuTitleWithLabel = ({
  className = '',
  classNameTitle = '',
  'data-testid': dataTestId,
  inlineMessage = '',
  inlineMessageType = '',
  label = '',
  title,
  required = false,
  theme = '',
}) => {
  return (
    <div>
      <div className={classnames(style['dropdown-menu-title-with-label'], className)} data-testid={dataTestId}>
        {label && <div className={style.label}>{label}</div>}
        <div className={classnames(style.title, classNameTitle)}>{title}</div>
        {required && <RequiredIndicator className={classnames(style['required-indicator'], style[theme])} />}
      </div>
      {inlineMessage && <InlineMessage type={inlineMessageType}>{inlineMessage}</InlineMessage>}
    </div>
  );
};

DropdownMenuTitleWithLabel.propTypes = {
  className: PropTypes.string,
  classNameTitle: PropTypes.string,
  'data-testid': PropTypes.string,
  inlineMessage: PropTypes.node,
  inlineMessageType: InlineMessageTypePropType,
  label: PropTypes.node,
  title: PropTypes.node.isRequired,
  required: PropTypes.bool,
  theme: PropTypes.oneOf(ButtonThemeService.getButtonThemes()),
};
